import ParsingCarSaveButton from './ParsingCarSaveButton';

export default ParsingCarSaveButton;